import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin, NestingLevelMixin} from '../common/common.js';
import Factory from './factory.js';

import './code.less';

const Code_ = Factory.createTag('code', '_code');

export const Code = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Code',
    nestingLevel: 'inline',
    classNames: {
      main: 'uu5-bricks-code'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getMainProps: function () {
    var mainProps = this.getMainPropsToPass();

    mainProps.id = this.getId() + '-code';
    mainProps.ignoreInnerHTML = true;
    mainProps.language = 'code';

    return mainProps;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
          <Code_ {...this._getMainProps()}>
            {this.props.children && React.Children.toArray(this.props.children)}
          </Code_>
        ) : null
    );
  }
  //@@viewOff:render
});

export default Code;



// WEBPACK FOOTER //
// ./bricks/code.js